import { render } from "./pageServiceCourse.vue?vue&type=template&id=036fc820&scoped=true"
import script from "./pageServiceCourse.vue?vue&type=script&lang=js"
export * from "./pageServiceCourse.vue?vue&type=script&lang=js"

import "./pageServiceCourse.vue?vue&type=style&index=0&id=036fc820&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036fc820"]])

export default __exports__